module.exports = __webpack_public_path__ + "whatsapp-logo.png?2c17527d7533f57dc9e09e587b5983b0";